<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="epigraph"><a id="start">It is a lovely thing to live with courage, and die leaving an everlasting fame.</a></p><a id="start">
<p class="right" style="margin-top:20px;">ALEXANDER</p>
<p class="center">You know that the more magnificent the prospect, the lesser the certainty, and also the greater the passion.</p>
<p class="right" style="margin-top:20px;">SIGMUND FREUD</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-epigraph.vue?5f1d03a5